import { render, staticRenderFns } from "./AddServiceClientAccessRightsWizard.vue?vue&type=template&id=05de39e0&scoped=true&"
import script from "./AddServiceClientAccessRightsWizard.vue?vue&type=script&lang=ts&"
export * from "./AddServiceClientAccessRightsWizard.vue?vue&type=script&lang=ts&"
import style0 from "./AddServiceClientAccessRightsWizard.vue?vue&type=style&index=0&id=05de39e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de39e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
